import { render } from "./DatatableInstance.vue?vue&type=template&id=f9368c82"
import script from "./DatatableInstance.vue?vue&type=script&lang=js"
export * from "./DatatableInstance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__